import { render, staticRenderFns } from "./bookingquestion.vue?vue&type=template&id=a20b6eea&scoped=true&"
import script from "./bookingquestion.vue?vue&type=script&lang=js&"
export * from "./bookingquestion.vue?vue&type=script&lang=js&"
import style0 from "./bookingquestion.vue?vue&type=style&index=0&id=a20b6eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20b6eea",
  null
  
)

export default component.exports